import { storeManager } from '@pressreader/appstore';

import { RESOURCES_MODULE_NAME } from '../constants';

import { reducer } from './reducer';
import { saga } from './sagas';

storeManager.addFeature(RESOURCES_MODULE_NAME, reducer, saga);

export { loadResourcesAction, resourcesChanged, resourcesLoadBegan, resourcesLoadDone, resourcesLoadFailed, templatesMerged } from './actions';
export { selectGetLocalizedString, selectStatus, selectTemplates } from './selectors';
